'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var iconStyles = require('../iconStyles.js');
var SvgIcon = require('../../node_modules/@material-ui/core/esm/SvgIcon/SvgIcon.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var MastercardCardLogo = function MastercardCardLogo(props) {
  return React__default["default"].createElement(SvgIcon["default"], _objectSpread({}, props, {
    viewBox: "0 0 145.27 93.77"
  }), React__default["default"].createElement("rect", {
    x: 2.9,
    y: 2.9,
    width: 139.47,
    height: 87.96,
    rx: 8.78,
    ry: 8.78,
    style: {
      fill: "none",
      stroke: "#151a1f",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "5.81px"
    }
  }), React__default["default"].createElement("path", {
    d: "M72.6 26.31c-2.32-1.88-4.93-3.25-7.75-4.2-4.07-1.38-8.24-1.76-12.49-1.07-7.79\n        1.27-13.85 5.25-18.17 11.83-2 3.04-3.22 6.41-3.76 10.02-.94 6.36.23 12.3 3.62\n        17.76 3.16 5.09 7.58 8.67 13.19 10.77 3.39 1.27 6.92 1.79 10.54 1.59 5.23-.28\n        9.95-1.98 14.18-5.04.19-.13.36-.28.54-.42l.08-.12c-.04-.14-.14-.22-.25-.3-1.01-.69-1.82-1.61-2.67-2.48a21.24\n        21.24 0 0 1-2.82-3.59c-1.22-1.94-2.22-3.98-2.93-6.17-.79-2.42-1.17-4.91-1.28-7.44-.05-1.1.08-2.19.18-3.29.21-2.27.76-4.46\n        1.56-6.59.56-1.48 1.27-2.88 2.09-4.23 1.02-1.68 2.23-3.2 3.58-4.62.79-.84 1.67-1.58 2.56-2.31v-.09Z",
    style: {
      fill: "#ed1c24"
    }
  }), React__default["default"].createElement("path", {
    d: "m72.6 67.42-.08.12c.2-.04.34.09.48.2a25.67 25.67 0 0 0 6.39 3.56c2.33.9 4.74 1.44 7.23 1.66 1.94.17 3.88.12\n        5.8-.14 2.9-.4 5.68-1.24 8.3-2.57 2.75-1.39 5.19-3.2 7.31-5.45 2.07-2.2 3.7-4.69 4.92-7.45 1.75-3.98 2.45-8.14\n        2.13-12.46-.32-4.42-1.71-8.52-4.14-12.24-2.16-3.31-4.93-6.02-8.31-8.08-2.52-1.53-5.21-2.63-8.1-3.25-3.6-.78-7.21-.81-10.81-.1-3.98.78-7.58 2.44-10.82\n        4.88-.09.07-.19.13-.28.2v.09c.55.28.99.71 1.43 1.11 1.4 1.29 2.69 2.69 3.81 4.24 1.48 2.07 2.62 4.32 3.43 6.73.71 2.1 1.19 4.25 1.32 6.49.12 2.01.09\n        4-.23 5.98-.5 3.11-1.52 6.04-3.06 8.78-1.54 2.73-3.54 5.08-5.91 7.12-.24.21-.44.5-.79.56Z",
    style: {
      fill: "#f8981d"
    }
  }), React__default["default"].createElement("path", {
    d: "M72.6 67.42c.35-.06.55-.35.79-.56 2.37-2.04 4.38-4.39 5.91-7.12 1.54-2.74 2.56-5.67\n        3.06-8.78.32-1.98.35-3.97.23-5.98-.13-2.23-.61-4.38-1.32-6.49-.81-2.41-1.95-4.66-3.43-6.73-1.11-1.56-2.41-2.95-3.81-4.24-.44-.41-.88-.84-1.43-1.11-.89.73-1.77\n        1.47-2.56 2.31-1.34 1.42-2.56 2.94-3.58 4.62-.82 1.35-1.54 2.76-2.09 4.23-.8 2.13-1.35 4.31-1.56 6.59-.1 1.1-.22\n        2.19-.18 3.29.11 2.54.49 5.02 1.28 7.44.71 2.19 1.71 4.23 2.93 6.17.82 1.29 1.75 2.5 2.82 3.59.85.86 1.66 1.78 2.67 2.48.11.07.21.16.25.3Z",
    style: {
      fill: "#f05423"
    }
  }));
};

var MastercardCardLogo$1 = iconStyles()(MastercardCardLogo);

module.exports = MastercardCardLogo$1;
